<template>
  <div>
    <!-- <el-table :data="userRecords">
      <el-table-column label="时间">
        <template slot-scope="scope">
          <span>{{scope.row.createdTime | moment}}</span>
        </template>
        </el-table-column>
        <el-table-column
          label="类型">
          <template slot-scope="scope">
            <span v-if="scope.row.txType==(1)">
              {{'充值'+scope.row.txCoin}}
            </span>
            <span v-if="scope.row.txType==(-1)">
              {{'提现'+scope.row.txCoin}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="(充值/提现)金额"
          prop="txAmount">
        </el-table-column>
        <el-table-column
          label="提现手续费"
          prop="txFee">
        </el-table-column>
        <el-table-column
          label="从"
          prop="txFromWallet">
        </el-table-column>
        <el-table-column
          label="至"
          prop="txToWallet">
        </el-table-column>
        <el-table-column
          label="hash">
          <template slot-scope="scope">
            <span v-if="scope.row.txHash">
              <a :href="scope.row.txHash" target="_blank">{{scope.row.txHash}}</a>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="__status"
          label="状态">
        </el-table-column>
      </el-table>
      <div class="user-withdrawal-pager-wrap">
        <pagination
          :size="pagination.size"
          :page="pagination.page"
          :total="userDetailTotal"
          @pageChanged="handleCurrentChange"
          >
        </pagination>
      </div> -->
      <balance></balance>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Pagination from 'components/pagination';
import Balance from '../balance';

export default {
  name: 'records',
  props: ['uid'],
  data() {
    return {
      pagination: {
        page: 1,
        size: 10
      }
    };
  },
  computed: {
    ...mapState('depositAudit', [
      'userRecords',
      'userDetailTotal',
      'userWallet'
    ])
  },
  components: {
    Pagination,
    Balance
  },
  methods: {
    ...mapActions('depositAudit', [
      'getUserRecords',
      'resetUserRecords',
      'getUserWallet'
    ]),
    getList() {
      this.getUserRecords({
        userId: this.uid,
        ...this.pagination
      });
    },
    handleCurrentChange(pagination) {
      this.pagination = pagination;
      this.getList();
    }
  },
  mounted() {
    // this.getList();
    this.getUserWallet({ userId: this.uid });
  },
  destroyed() {
    this.resetUserRecords();
  }
};
</script>
